
const listStudent = [
  {
    FullName: 'Nguyễn Quốc An',
    DateOfBrith: '22/04/2006',
    TotalSubmit: '27/30',
    RatingSubmit: '90%',
    CorrectAnswer: '251/270',
    RatingCorrect: '93%'
  },
  {
    FullName: 'Nguyễn Văn An',
    DateOfBrith: '22/03/2006',
    TotalSubmit: '27/30',
    RatingSubmit: '90%',
    CorrectAnswer: '238/270',
    RatingCorrect: '88%'
  },
  {
    FullName: 'Nguyễn Ngọc Quỳnh Anh',
    DateOfBrith: '17/12/2006',
    TotalSubmit: '29/30',
    RatingSubmit: '97%',
    CorrectAnswer: '207/290',
    RatingCorrect: '71%'
  },
  {
    FullName: 'Hồ Thiên Bảo',
    DateOfBrith: '27/10/2006',
    TotalSubmit: '27/30',
    RatingSubmit: '90%',
    CorrectAnswer: '242/270',
    RatingCorrect: '90%'
  },
  {
    FullName: 'Nguyễn Thành Công',
    DateOfBrith: '25/10/2006',
    TotalSubmit: '20/30',
    RatingSubmit: '67%',
    CorrectAnswer: '200/200',
    RatingCorrect: '100%'
  },
  {
    FullName: 'Hồ Thành Danh',
    DateOfBrith: '17/07/2006',
    TotalSubmit: '29/30',
    RatingSubmit: '97%',
    CorrectAnswer: '244/290',
    RatingCorrect: '84%'
  },
  {
    FullName: 'Võ Tấn Dũng',
    DateOfBrith: '13/04/2006',
    TotalSubmit: '25/30',
    RatingSubmit: '83%',
    CorrectAnswer: '236/250',
    RatingCorrect: '94%'
  },
  {
    FullName: 'Lê Nguyễn Thùy Dương',
    DateOfBrith: '18/10/2006',
    TotalSubmit: '24/30',
    RatingSubmit: '80%',
    CorrectAnswer: '213/240',
    RatingCorrect: '89%'
  },
  {
    FullName: 'Đặng Trùng Dương',
    DateOfBrith: '13/06/2006',
    TotalSubmit: '22/30',
    RatingSubmit: '73%',
    CorrectAnswer: '218/220',
    RatingCorrect: '99%'
  },
  {
    FullName: 'Phạm Hữu Duy',
    DateOfBrith: '11/06/2006',
    TotalSubmit: '25/30',
    RatingSubmit: '83%',
    CorrectAnswer: '203/250',
    RatingCorrect: '81%'
  },
  {
    FullName: 'Bùi Thị Mỹ Duyên',
    DateOfBrith: '28/06/2006',
    TotalSubmit: '20/30',
    RatingSubmit: '67%',
    CorrectAnswer: '200/200',
    RatingCorrect: '100%'
  },
  {
    FullName: 'Nguyễn Hồ Tuấn Hào',
    DateOfBrith: '12/03/2006',
    TotalSubmit: '29/30',
    RatingSubmit: '97%',
    CorrectAnswer: '210/290',
    RatingCorrect: '72%'
  },
  {
    FullName: 'Đỗ Minh Hiếu',
    DateOfBrith: '19/01/2006',
    TotalSubmit: '29/30',
    RatingSubmit: '97%',
    CorrectAnswer: '254/290',
    RatingCorrect: '88%'
  },
  {
    FullName: 'Đỗ Trung Hiếu',
    DateOfBrith: '01/03/2006',
    TotalSubmit: '23/30',
    RatingSubmit: '77%',
    CorrectAnswer: '200/230',
    RatingCorrect: '87%'
  },
  {
    FullName: 'Nguyễn Phi Hoàng',
    DateOfBrith: '17/06/2006',
    TotalSubmit: '21/30',
    RatingSubmit: '70%',
    CorrectAnswer: '200/210',
    RatingCorrect: '95%'
  },
  {
    FullName: 'Nguyễn Quang Huy',
    DateOfBrith: '31/08/2004',
    TotalSubmit: '30/30',
    RatingSubmit: '100%',
    CorrectAnswer: '226/300',
    RatingCorrect: '75%'
  },
  {
    FullName: 'Phan Tuấn Kiệt',
    DateOfBrith: '16/09/2006',
    TotalSubmit: '28/30',
    RatingSubmit: '93%',
    CorrectAnswer: '219/280',
    RatingCorrect: '78%'
  },
  {
    FullName: 'Trần Hoàng Long',
    DateOfBrith: '16/07/2006',
    TotalSubmit: '29/30',
    RatingSubmit: '97%',
    CorrectAnswer: '283/290',
    RatingCorrect: '98%'
  },
  {
    FullName: 'Hồ Long',
    DateOfBrith: '31/05/2006',
    TotalSubmit: '20/30',
    RatingSubmit: '67%',
    CorrectAnswer: '200/200',
    RatingCorrect: '100%'
  },
  {
    FullName: 'Nguyễn Gia Minh',
    DateOfBrith: '29/04/2006',
    TotalSubmit: '22/30',
    RatingSubmit: '73%',
    CorrectAnswer: '206/220',
    RatingCorrect: '94%'
  },
  {
    FullName: 'Nguyễn Thị Châu Ngân',
    DateOfBrith: '13/03/2006',
    TotalSubmit: '27/30',
    RatingSubmit: '90%',
    CorrectAnswer: '250/270',
    RatingCorrect: '93%'
  },
  {
    FullName: 'Hứa Ngọc Xuân Nguyên',
    DateOfBrith: '28/01/2006',
    TotalSubmit: '20/30',
    RatingSubmit: '67%',
    CorrectAnswer: '200/200',
    RatingCorrect: '100%'
  },
  {
    FullName: 'Trương Thị Yến Nhi',
    DateOfBrith: '23/02/2006',
    TotalSubmit: '26/30',
    RatingSubmit: '87%',
    CorrectAnswer: '218/260',
    RatingCorrect: '84%'
  },
  {
    FullName: 'Phạm Song Như',
    DateOfBrith: '27/05/2006',
    TotalSubmit: '26/30',
    RatingSubmit: '87%',
    CorrectAnswer: '236/260',
    RatingCorrect: '91%'
  },
  {
    FullName: 'Hồng Tuấn Phát',
    DateOfBrith: '20/10/2006',
    TotalSubmit: '20/30',
    RatingSubmit: '67%',
    CorrectAnswer: '200/200',
    RatingCorrect: '100%'
  },
  {
    FullName: 'Đào Thành Phát',
    DateOfBrith: '03/09/2006',
    TotalSubmit: '22/30',
    RatingSubmit: '73%',
    CorrectAnswer: '210/220',
    RatingCorrect: '95%'
  },
  {
    FullName: 'Bùi Nguyễn Diễm Phúc',
    DateOfBrith: '22/05/2006',
    TotalSubmit: '28/30',
    RatingSubmit: '93%',
    CorrectAnswer: '264/280',
    RatingCorrect: '94%'
  },
  {
    FullName: 'Nguyễn Hoàng Kim Phượng',
    DateOfBrith: '27/11/2006',
    TotalSubmit: '28/30',
    RatingSubmit: '93%',
    CorrectAnswer: '231/280',
    RatingCorrect: '83%'
  },
  {
    FullName: 'Nguyễn Trần Thanh Quang',
    DateOfBrith: '23/12/2006',
    TotalSubmit: '29/30',
    RatingSubmit: '97%',
    CorrectAnswer: '289/290',
    RatingCorrect: '100%'
  },
  {
    FullName: 'Nguyễn Thái Minh Sơn',
    DateOfBrith: '27/11/2006',
    TotalSubmit: '20/30',
    RatingSubmit: '67%',
    CorrectAnswer: '200/200',
    RatingCorrect: '100%'
  }
]
const listExercises = [
  {
    Title: 'Bài tập cuối tuần 10',
    Week: '10',
    ChoiceQuestion: '10',
    RatingSubmit: '92%',
    RatingCorrect: '90%'
  },
  {
    Title: 'Ôn tập Căn thức bậc hai và hằng đẳng thức',
    Week: '10',
    ChoiceQuestion: '10',
    RatingSubmit: '88%',
    RatingCorrect: '95%'
  },
  {
    Title: 'Hàm số bậc nhất',
    Week: '10',
    ChoiceQuestion: '10',
    RatingSubmit: '96%',
    RatingCorrect: '80%'
  },
  {
    Title: 'Luyện tập Tứ giác nội tiếp',
    Week: '10',
    ChoiceQuestion: '10',
    RatingSubmit: '92%',
    RatingCorrect: '60%'
  },
  {
    Title: 'Bài tập cuối tuần 09',
    Week: '9',
    ChoiceQuestion: '10',
    RatingSubmit: '89%',
    RatingCorrect: '80%'
  },
  {
    Title: 'Luyện tập phương trình bậc 2',
    Week: '9',
    ChoiceQuestion: '10',
    RatingSubmit: '93%',
    RatingCorrect: '95%'
  },
  {
    Title: 'Chuyên đề Căn bậc ba',
    Week: '9',
    ChoiceQuestion: '10',
    RatingSubmit: '85%',
    RatingCorrect: '94%'
  },
  {
    Title: 'Bài tập cuối tuần 08',
    Week: '8',
    ChoiceQuestion: '10',
    RatingSubmit: '80%',
    RatingCorrect: '90%'
  },
  {
    Title: 'Liên hệ giữa phép chia và phép khai phương',
    Week: '8',
    ChoiceQuestion: '10',
    RatingSubmit: '74%',
    RatingCorrect: '70%'
  },
  {
    Title: 'Ôn tập chương I',
    Week: '8',
    ChoiceQuestion: '10',
    RatingSubmit: '68%',
    RatingCorrect: '85%'
  }
]
const listTopic = [
  {
    Topic: 'Căn thức bậc hai và hằng đẳng thức',
    NumberExcercise: '3',
    RatingCorrect: '83%'
  },
  {
    Topic: 'Liên hệ giữa phép chia và phép khai phương',
    NumberExcercise: '3',
    RatingCorrect: '87%'
  },
  {
    Topic: 'Hàm số bậc nhất',
    NumberExcercise: '5',
    RatingCorrect: '80%'
  },
  {
    Topic: 'Góc nội tiếp',
    NumberExcercise: '3',
    RatingCorrect: '77%'
  },
  {
    Topic: 'Căn bậc ba',
    NumberExcercise: '6',
    RatingCorrect: '87%'
  },
  {
    Topic: 'Đường thẳng song song và đường thẳng cắt nhau',
    NumberExcercise: '4',
    RatingCorrect: '85%'
  },
  {
    Topic: 'Đồ thị của hàm số y = ax + b (a 0)',
    NumberExcercise: '4',
    RatingCorrect: '78%'
  },
  {
    Topic: 'Giải hệ phương trình bằng phương pháp cộng',
    NumberExcercise: '5',
    RatingCorrect: '88%'
  },
  {
    Topic: 'Giải bài toán bằng cách lập hệ phương trình',
    NumberExcercise: '7',
    RatingCorrect: '89%'
  },
  {
    Topic: 'Góc tạo bởi tia tiếp tuyến và dây cung',
    NumberExcercise: '5',
    RatingCorrect: '96%'
  }
]

export { listStudent, listExercises, listTopic }
